import { useSelector, useDispatch, batch } from 'react-redux'
import { RootState } from '../reducers/rootReducer';

import { SET_IMAGE, SET_NAME, SET_FORMAT, SET_DIMENSION, SET_PROPORTIONS } 
from '../constants/imageConstants';

export default function ImageActions() {
   const dispatch = useDispatch();

   const image = useSelector((state: RootState) => state.imageReducer.image);
   const name = useSelector((state: RootState) => state.imageReducer.name);
   const format = useSelector((state: RootState) => state.imageReducer.format);
   const width = useSelector((state: RootState) => state.imageReducer.width);
   const height = useSelector((state: RootState) => state.imageReducer.height);

   const setImage: Function = (image: File) => {
      dispatch({ type: SET_IMAGE, image: URL.createObjectURL(image) });
      dispatch({ type: SET_NAME, name: image.name });
      dispatch({ type: SET_FORMAT, format: image.type });
   }
   
   const setDimension: Function = ( height: number, width: number) => {
      dispatch({ type: SET_DIMENSION, width: width, height: height });
   }

   const clearImage: Function = () => {
      dispatch({ type: SET_IMAGE, image: '' });
      dispatch({ type: SET_NAME, name: '' });
      dispatch({ type: SET_FORMAT, format: '' });
      dispatch({ type: SET_DIMENSION, width: 0, height: 0 });
      dispatch({ type: SET_PROPORTIONS, properties: true});
   }


   return { 
      image: image,
      imageName: name,
      imageFormat: format,
      imageWidth: width,
      imageHeight: height,
      imageFlipVertical: false, 
      imageFlipHorizontal: false,
      imageClear: clearImage,
      imageSetDimension: setDimension,
      imageSet: setImage
    }
}

